import React from "react";

export default function LoadingSpinner() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      style={{ animation: "v-spin 0.9s linear infinite" }}
    >
      <style>{`
        @keyframes v-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <circle
        cx="18"
        cy="18"
        r="15"
        fill="none"
        stroke="#e5e7eb"
        strokeWidth="3"
      />
      <circle
        cx="18"
        cy="18"
        r="15"
        fill="none"
        stroke="#4C75AB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="70 30"
      />
    </svg>
  );
}
